module.exports = __webpack_public_path__ + "static/media/quote.ac98b71b.svg";